export var urlgetPictureList = '/api/XOrg/BookMaterial/getPictureList';
import http from 'lib//http';
export function getPictureList(id) {
  return http.post(urlgetPictureList, {
    id: id
  });
} //获取当前课程下所有的课程

export var urlgetFaceTeachList = '/api/XOrg/BookMaterial/getFaceTeachList';
export function getFaceTeachList(courseId, faceName, classId, pageSize, page) {
  return http.post(urlgetFaceTeachList, {
    courseId: courseId,
    faceName: faceName,
    classId: classId,
    pageSize: pageSize,
    page: page
  });
} //添加资源列表

export var urlAddSource = '/api/XOrg/BookMaterial/AddSource';
export function AddSource(Id, faceId, classId, courseId) {
  return http.post(urlAddSource, {
    Id: Id,
    faceId: faceId,
    classId: classId,
    courseId: courseId
  });
} //获取课程下所有的班级

export var urlgetClassList = '/api/XOrg/BookMaterial/getClassList';
export function getClassList(courseId) {
  return http.post(urlgetClassList, {
    courseId: courseId
  });
}